import yup from '../../../config/yup';

export const sleepValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('sleep'),
  action: yup.string().default('SLEEP').required('Action is required'),
  command: yup
    .string()
    .default('SLEEP')
    .required('Command is required')
    .matches(/^SLEEP\s+\S+/i, "Command must start with 'SLEEP' followed by at least one word"),
  duration: yup.number().required('Duration is required'),
});
